var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaptiveRatio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.625H10.375C12.2315 0.625 14.012 1.3625 15.3247 2.67525C16.6375 3.98801 17.375 5.76848 17.375 7.625V8.5H9.5V0.625ZM10.375 7.625H16.5C16.5 6.00055 15.8547 4.44263 14.706 3.29397C13.5574 2.14531 11.9995 1.5 10.375 1.5V7.625ZM7.75 10.25H14.75C14.75 12.1065 14.0125 13.887 12.6997 15.1997C11.387 16.5125 9.60652 17.25 7.75 17.25C5.89348 17.25 4.11301 16.5125 2.80025 15.1997C1.4875 13.887 0.75 12.1065 0.75 10.25C0.75 8.39348 1.4875 6.61301 2.80025 5.30025C4.11301 3.9875 5.89348 3.25 7.75 3.25V10.25ZM6.875 11.125V4.18625C3.90875 4.615 1.625 7.16125 1.625 10.25C1.625 11.8745 2.27031 13.4324 3.41897 14.581C4.56763 15.7297 6.12555 16.375 7.75 16.375C10.8387 16.375 13.385 14.0913 13.8138 11.125H6.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptiveRatio);
export default __webpack_public_path__ + "static/media/captive_ratio.fc800c6fed11f2763fc7816082ecd376.svg";
export { ForwardRef as ReactComponent };